export enum TipType {
  fixed = 'fixed',
  percent = 'percent',
  manual = 'manual',
}
